/**
 * @generated SignedSource<<8d6dc333f79713acb0ed727cbb12aa7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ApplyAssigneesBulkActionIssueFragment$data = {
  readonly assignedActors: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename?: string;
        readonly avatarUrl?: string;
        readonly displayName?: string;
        readonly id?: string;
        readonly isAgent?: boolean;
        readonly isCopilot?: boolean;
        readonly login?: string;
        readonly name?: string | null | undefined;
        readonly profileResourcePath?: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  };
  readonly id: string;
  readonly repository: {
    readonly databaseId: number | null | undefined;
    readonly isArchived: boolean;
    readonly isPrivate: boolean;
  };
  readonly " $fragmentType": "ApplyAssigneesBulkActionIssueFragment";
};
export type ApplyAssigneesBulkActionIssueFragment$key = {
  readonly " $data"?: ApplyAssigneesBulkActionIssueFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ApplyAssigneesBulkActionIssueFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ApplyAssigneesBulkActionIssueFragment"
};

(node as any).hash = "cfd951e7b26297e9fc44cf7a61f6b9de";

export default node;
